/*! @hebcal/hdate v0.22.2, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */
import { abs2greg, daysInGregMonth, greg2abs, isDate, isGregLeapYear } from './greg.js';

/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Gregorian date helper functions
 */
var greg;
(function (greg) {
})(greg || (greg = {}));
greg.abs2greg = abs2greg;
greg.daysInMonth = daysInGregMonth;
greg.greg2abs = greg2abs;
greg.isDate = isDate;
greg.isLeapYear = isGregLeapYear;

export { greg };
//# sourceMappingURL=gregNamespace.js.map
